import React, { ReactNode } from 'react';

import { StyleSheet, View, ViewStyle } from 'react-native';

import {
    Edge,
    SafeAreaView,
    initialWindowMetrics,
} from 'react-native-safe-area-context';
import { useSelector } from 'react-redux';

import { selectLayoutConfig } from 'store/config/selectors';

import useSafeAreaEdges from 'utils/hooks/useSafeAreaEdges';
import { isAndroid15, isTablet } from 'utils/responsiveness';

import { underlayingPlayerModalElementsDataSet } from 'screens/PlayerModal/hooks/useModalAccessibility.ts';

type Props = {
    useSafeArea?: boolean;
    children: ReactNode;
    style?: ViewStyle | ViewStyle[];
    importantForAccessibility?:
        | 'auto'
        | 'yes'
        | 'no'
        | 'no-hide-descendants'
        | undefined;
    accessibilityElementsHidden?: boolean | undefined;
};

const DetailRootView: React.FC<Props> = ({
    useSafeArea = true,
    children,
    style,
    importantForAccessibility = 'auto',
    accessibilityElementsHidden,
}) => {
    const genericEdges: Edge[] = useSafeAreaEdges();
    const edges: Edge[] = [...genericEdges, 'top'];
    const { background } = useSelector(selectLayoutConfig);

    if (useSafeArea) {
        return (
            <SafeAreaView
                edges={isTablet ? edges : genericEdges}
                style={style}
                accessible={false}
                importantForAccessibility={importantForAccessibility}
                accessibilityElementsHidden={accessibilityElementsHidden}
                dataSet={underlayingPlayerModalElementsDataSet}
            >
                {isAndroid15 && (
                    <View
                        style={[
                            StyleSheet.absoluteFill,
                            {
                                backgroundColor: background,
                                height: initialWindowMetrics?.insets.top,
                                zIndex: 100,
                            },
                        ]}
                    />
                )}
                {children}
            </SafeAreaView>
        );
    }

    return (
        <View
            style={style}
            accessible={false}
            importantForAccessibility={importantForAccessibility}
            accessibilityElementsHidden={accessibilityElementsHidden}
            dataSet={underlayingPlayerModalElementsDataSet}
        >
            {children}
        </View>
    );
};

export default DetailRootView;
